var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollWrapper",staticClass:"scroll-wrapper",class:[_vm.direction]},[_c('div',{staticClass:"scroll-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }